// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-form-item-control-input-content .ant-row.ant-form-item {
  display: flex;
  flex-direction: row !important;
  align-items: center;
}

.ant-form-item-control-input-content .ant-row.ant-form-item:last-child {
  margin-bottom: 0 !important;
}

.ant-form-item-control-input-content .ant-form-item-label {
  width: 20%;
}

.ant-form-item-control-input-content .ant-form-item-control {
  width: 50%;
}

.ant-form-item-control-input-content .ant-select-selector {
  font-size: 12px !important;
  border: none !important;
  box-shadow: -2px 2px 6px 1px rgba(0, 0, 0, 0.05);
}

.ant-form-item-control-input-content .ant-select-selection-placeholder, .ant-form-item-control-input-content .ant-select-selection-item {
  display: flex;
  align-items: center;
}

.ant-col.ant-form-item-label {
  padding-bottom: 0 !important;
}`, "",{"version":3,"sources":["webpack://./js/view/component/form-items/sites-user-type-select/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,0BAAA;EACA,uBAAA;EACA,gDAAA;AACF;;AAEA;EAEE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,4BAAA;AACF","sourcesContent":[":global .ant-form-item-control-input-content .ant-row.ant-form-item {\n  display: flex;\n  flex-direction: row !important;\n  align-items: center;\n}\n\n:global .ant-form-item-control-input-content .ant-row.ant-form-item:last-child {\n  margin-bottom: 0 !important;\n}\n\n:global .ant-form-item-control-input-content .ant-form-item-label {\n  width: 20%;\n}\n\n:global .ant-form-item-control-input-content .ant-form-item-control {\n  width: 50%;\n}\n\n:global .ant-form-item-control-input-content .ant-select-selector {\n  font-size: 12px !important;\n  border: none !important;\n  box-shadow: -2px 2px 6px 1px rgba(0, 0, 0, 0.05);\n}\n\n:global .ant-form-item-control-input-content .ant-select-selection-placeholder,\n:global .ant-form-item-control-input-content .ant-select-selection-item {\n  display: flex;\n  align-items: center;\n}\n\n:global .ant-col.ant-form-item-label {\n  padding-bottom: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
